import script from "./LightweightChart.vue?vue&type=script&setup=true&lang=js"
export * from "./LightweightChart.vue?vue&type=script&setup=true&lang=js"

import "./LightweightChart.vue?vue&type=style&index=0&id=fe8bbd56&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe8bbd56"]])

export default __exports__